
<template>
    
        <mars-view><c-popup v-if="applyPhone" :show="showPopup" class="my-consult-detail-popup"><mars-swiper :current="popupIdx" display-multiple-items="1" class="my-consult-detail-popup-swiper" @change="swiperChangeFn"><mars-swiper-item><mars-view class="c-container c-gap-inner-top-zero"><mars-view class="c-row"><mars-view class="c-span1"></mars-view><mars-view class="c-span10 l-title l-text-center apply-popup-title">
                            {{ applyPhone.title }}
                        </mars-view><mars-view class="c-span1 l-span-right apply-popup-title-right" @click.native.stop="tapBtnFn('拒绝', true)"><mars-view class="icon iconfont title-close"></mars-view></mars-view></mars-view><mars-view class="c-color-normal c-gap-top c-gap-bottom apply-popup-text">
                        {{ applyPhone.name }}申请获取您的联系电话，方便律师根据您的问题为您提供法律服务
                    </mars-view><mars-view class="phone-box-wrapper"><mars-text class="c-gap-right-large">{{ applyPhone.phone }}</mars-text><mars-text class="c-color-gray">百度账号绑定号码</mars-text></mars-view><mars-view class="apply-popup-rule" @click.native="handleCheck('phoneApply')"><mars-view class="apply-popup-checkbox" :class="phoneApply ? 'apply-popup-check' : 'apply-popup-uncheck'"></mars-view><mars-view>
                            我同意当前服务方获取我的真实手机号
                        </mars-view></mars-view><mars-view class="apply-popup-rule" @click.native="handleCheck('tpApply')"><mars-view class="apply-popup-checkbox" :class="tpApply ? 'apply-popup-check' : 'apply-popup-uncheck'"></mars-view><mars-view>免费升级:获得另外3家<mars-text class="apply-popup-tp" @click.native.stop="togglePopupFn(true)">优质法律服务机构</mars-text>致电</mars-view></mars-view><mars-view class="apply-popup-button" :style="{'background-color': (!tpApply && !phoneApply) ? '#445FBBaa' : '#445FBB'}" @click.native="tapBtnFn('允许')">同意授权</mars-view></mars-view></mars-swiper-item><mars-swiper-item v-if="applyPhone.explain"><mars-view class="c-container c-gap-inner-top-zero apply-popup-intro"><mars-view><mars-view class="c-row"><mars-view class="c-span1"></mars-view><mars-view class="c-span10 l-title l-text-center apply-popup-title">
                                法律服务方说明
                            </mars-view><mars-view class="c-span1 l-span-right apply-popup-title-right" @click.native.stop="togglePopupFn(false)"><mars-view class="icon iconfont title-close"></mars-view></mars-view></mars-view><mars-view class="c-color-normal c-gap-top c-gap-bottom">
                            法律服务方包含：律临认证律师、瀛和律师机构、法律部落、效律网、大律科技、湖南旷真（北京）律师事务所、君达法律咨询。
                        </mars-view></mars-view><mars-view><popup-bootom></popup-bootom></mars-view></mars-view></mars-swiper-item></mars-swiper></c-popup></mars-view>
    
</template>

<script>
import Popup from "../../components/common/popup.vue";
import { act } from '../../static/utils/navigate.js';
import popupBootom from "../../components/chat/popupBootom.vue";
let islock = false;
export default {
  components: {
    'c-popup': Popup,
    'popup-bootom': popupBootom
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    applyPhone: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      showPopup: false,
      popupIdx: 0,
      isLock: false,
      phoneApply: true,
      tpApply: true
    };
  },
  mounted() {
    this.showPopup = this.show;
  },
  methods: {
    tapBtnFn(txt, isClose = false) {
      if (islock) {
        return;
      }
      if (txt === '允许' && !this.phoneApply && !this.tpApply) {
        return;
      }
      if (!this.phoneApply) {
        txt = '拒绝';
      }
      // 埋点添加req1、req2 代表成功选择授权的选项
      this.$emit('applyPhoneClick', {
        txt,
        req1: isClose ? false : this.phoneApply,
        req2: isClose ? false : this.tpApply
      });
      islock = true;
      const btnParams = this.applyPhone.btns && this.applyPhone.btns.filter(item => item.txt === txt);
      const url = btnParams[0].url + `&approve_cnt=${this.tpApply && !isClose ? '3' : '0'}`;
      act({
        target: url,
        type: 'post'
      }).then(() => {
        this.showPopup = false;
      }).catch(err => {
        console.log(err); // eslint-disable-line
      }).finally(() => {
        setTimeout(() => {
          islock = false;
        }, 1000);
      });
    },
    togglePopupFn(dir) {
      this.popupIdx = +dir;
    },
    closePopupFn() {
      this.showPopup = false;
    },
    swiperChangeFn(e) {
      this.popupIdx = e.detail.current;
    },
    handleCheck(checkName) {
      this[checkName] = !this[checkName];
    }
  }
};
</script>

<style scoped>
.my-consult-card-wrapper:not(:last-child) {
  margin-bottom: 8px;
}
.my-consult-detail-popup .phone-box-wrapper {
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
  padding: 10px 0;
}
.my-consult-detail-popup-swiper {
  min-height: 335px;
}
.my-consult-detail-popup /deep/ .c-container {
  padding: 0 17px;
}
.my-consult-detail-popup [class*='__c-container'] {
  padding: 0 17px;
}
.apply-popup-title-right {
  position: relative;
}
.apply-popup-title-right .title-close {
  position: absolute;
  font-size: 16px;
  color: #999;
  top: 0;
  right: 0;
  line-height: 55px;
  height: 55px;
  text-align: center;
}
.apply-popup-title {
  height: 55px;
  line-height: 55px;
  font-family: PingFangSC-Medium;
  font-size: 19px;
  color: #000;
}
.apply-popup-text {
  font-size: 16px;
  margin: -3px 0;
  margin-bottom: 18px;
}
.apply-popup-rule {
  display: flex;
  line-height: 20px;
  font-size: 14px;
  color: #b8b8b8;
  margin-top: 18px;
  margin: 15px 0 -3px;
}
.apply-popup-checkbox {
  margin-top: 3px;
  margin-right: 6px;
  width: 14px;
  height: 14px;
  background: url('https://law-smartapp.cdn.bcebos.com/prosecute/p-not-selected.png') center center no-repeat;
  border-radius: 50%;
  background-size: 100% 100%;
}
.apply-popup-check {
  background-image: url('https://law-smartapp.cdn.bcebos.com/prosecute/p-active-selected.png');
}
.apply-popup-uncheck {
  background-image: url('https://law-smartapp.cdn.bcebos.com/prosecute/p-not-selected.png');
}
.apply-popup-button {
  margin: 21px 0;
  height: 44px;
  line-height: 44px;
  background: #445fbb;
  border-radius: 24px;
  font-family: PingFangSC-Medium;
  font-size: 15px;
  color: #fff;
  text-align: center;
  font-weight: 500;
}
.apply-popup-tp {
  color: #445fbb;
}
.apply-popup-intro {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

</style>
